import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0B0B0B", // this a black color
      silver: "#F2F2F2",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      white: "#FFFFFF",
      whiteHover: "#E2E2E2",
    },
    colors: {
      BlackBean: "#0B0B0B",
    },
  },
  typography: {
    fontFamily: "Avenir LT Std, Roboto, sans-serif",
    fontSize: 16,
    Poppins: "'Poppins', sans-serif",
    Nunito: "'Nunito Sans', sans-serif;",
  },
  authTitle: {
    fontFamily: "Avenir LT Std, Roboto, sans-serif",
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "24px",
    lineHeight: "33px",
    color: "#0B0B0B",
  },
  authsubTit: {
    fontFamily: "Avenir LT Std, Roboto, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
